module.exports = __webpack_public_path__ + "img/af7f4d2af015e10decb6d3d67b04cdd2.png";